import React from "react";

function ResumeIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="9"
      height="11"
      viewBox="0 0 9 11"
      fill="none"
    >
      <path
        d="M8.39769 5.84837L0.858384 10.4782C0.804866 10.511 0.74273 10.5298 0.678555 10.5326C0.614379 10.5355 0.550554 10.5224 0.493835 10.4946C0.437115 10.4668 0.389614 10.4254 0.356359 10.3747C0.323105 10.3241 0.305335 10.2661 0.304932 10.207V0.947272C0.305122 0.88801 0.322737 0.829901 0.355905 0.779117C0.389074 0.728333 0.436558 0.68677 0.493315 0.658841C0.550072 0.630912 0.613982 0.61766 0.67826 0.620492C0.742538 0.623325 0.804782 0.642136 0.858384 0.674929L8.39769 5.30368C8.44669 5.33361 8.48688 5.37424 8.51468 5.42195C8.54249 5.46966 8.55704 5.52297 8.55704 5.57712C8.55704 5.63126 8.54249 5.68457 8.51468 5.73228C8.48688 5.77999 8.44669 5.82062 8.39769 5.85055V5.84837Z"
        fill="white"
      />
    </svg>
  );
}

export default ResumeIcon;
